// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  padding: 0;
  border: 0;
}

#search-divider #filter-btn {
  --padding-end: 24px;
}

#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
}
#subtitle-2 #product-stock-title,
#subtitle-2 #product-stock-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #product-stock-title {
  margin-left: 24px;
  font-size: 17px;
  font-weight: 700;
}
#subtitle-2 #product-stock-add {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}
#subtitle-2 #product-stock-add ion-button {
  --padding-end: 24px;
  text-transform: capitalize;
}
#subtitle-2 #product-stock-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.store-item {
  font-size: 14px;
}
.store-item.item-title {
  font-weight: 700;
  color: var(--ion-color-dark);
}
.store-item.item-price {
  font-weight: 700;
  color: var(--ion-color-primary);
}

ion-item.hidden-product {
  --detail-icon-opacity: 0.35;
}
ion-item.hidden-product ion-label {
  opacity: 0.35;
}
ion-item.hidden-product ion-thumbnail {
  position: relative;
  width: 64px;
  height: 64px;
  --border-radius: 8px;
}
ion-item.hidden-product ion-thumbnail .product-hidden-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background: white;
  text-align: center;
  opacity: 0.8;
}

ion-thumbnail {
  justify-content: center;
  display: flex;
}
ion-thumbnail img {
  border-radius: 6px;
}

.thumbnail-no-image {
  background: #acc5e3;
  border-radius: 6px;
}
.thumbnail-no-image ion-label {
  font-size: 15px;
  font-weight: bold;
}

.container-close {
  margin-right: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/store/components/coupons/product-list/product-list.page.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;AACJ;;AAOI;EACE,mBAAA;AAJN;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AALJ;AAOI;;EAEE,UAAA;EACA,4BAAA;AALN;AAOI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AALN;AAQI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AANN;AAOM;EACE,mBAAA;EACA,0BAAA;AALR;AAMQ;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AAJV;;AAUE;EACE,eAAA;AAPJ;AASI;EACE,gBAAA;EACA,4BAAA;AAPN;AASI;EACE,gBAAA;EACA,+BAAA;AAPN;;AAWE;EACE,2BAAA;AARJ;AASI;EACE,aAAA;AAPN;AASI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAPN;AASM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAPR;;AAaE;EAEE,uBAAA;EACA,aAAA;AAXJ;AAaI;EACE,kBAAA;AAXN;;AAiBE;EACE,mBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,eAAA;EACA,iBAAA;AAdN;;AAkBE;EACE,4BAAA;AAfJ","sourcesContent":["ion-item-divider {\n    padding: 0;\n    border: 0;\n  }\n  \n  #search-divider {\n    // ion-searchbar {\n    //   margin-right: 0;\n    // }\n  \n    #filter-btn {\n      --padding-end: 24px;\n    }\n  }\n  \n  #subtitle-2 {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding-top: 16px;\n    padding-bottom: 16px;\n  \n    #product-stock-title,\n    #product-stock-add {\n      width: 50%;\n      color: var(--ion-text-color);\n    }\n    #product-stock-title {\n      margin-left: 24px;\n      font-size: 17px;\n      font-weight: 700;\n    }\n  \n    #product-stock-add {\n      font-size: 14px;\n      font-weight: 500;\n      text-align: right;\n      ion-button {\n        --padding-end: 24px;\n        text-transform: capitalize;\n        ion-icon {\n          margin-right: 3px;\n          width: 32px !important;\n          height: 32px !important;\n        }\n      }\n    }\n  }\n  \n  .store-item {\n    font-size: 14px;\n  \n    &.item-title {\n      font-weight: 700;\n      color: var(--ion-color-dark);\n    }\n    &.item-price {\n      font-weight: 700;\n      color: var(--ion-color-primary);\n    }\n  }\n  \n  ion-item.hidden-product {\n    --detail-icon-opacity: 0.35;\n    ion-label {\n      opacity: 0.35;\n    }\n    ion-thumbnail {\n      position: relative;\n      width: 64px;\n      height: 64px;\n      --border-radius: 8px;\n  \n      .product-hidden-overlay {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: auto;\n        width: 100%;\n        height: 100%;\n        background: white;\n        text-align: center;\n        opacity: 0.8;\n      }\n    }\n  }\n  \n  \n  ion-thumbnail {\n    //align-items: center;\n    justify-content: center;\n    display: flex;\n  \n    img {\n      border-radius: 6px;\n      //width: auto;\n      //height: auto;\n    }\n  }\n  \n  .thumbnail-no-image{\n    background: #acc5e3;\n    border-radius: 6px;\n  \n    ion-label{\n      font-size: 15px;\n      font-weight: bold;\n    }\n  }\n\n  .container-close{\n    margin-right: 0px !important;\n  }\n  \n  //PWA\n  @media (min-width: 960px) {\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
